'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Link = require('./Link');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Link).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Link/index.js
// module id = 1220
// module chunks = 1